export default {
    takerVolumeData: [],
    openInterestData: [],
    indexPriceHistoryData: [],
    fundingRateRealTimeData: [],
    fundingRateHistoryData: [],
};